import { useEffect, useState } from 'react';
import { CATEGORIES, FEED_ITEMS } from '@/mocks/data';

const catColor: Record<string, string> = {
  娱乐: 'bg-primary-100 text-primary-700',
  科技: 'bg-secondary-100 text-secondary-700',
  社会: 'bg-accent-100 text-accent-800',
  网络: 'bg-background-200 text-foreground-700',
  生活: 'bg-secondary-100 text-secondary-800',
  体育: 'bg-accent-100 text-accent-700',
  财经: 'bg-primary-100 text-primary-700',
};

const tagColor: Record<string, string> = {
  爆: 'bg-primary-500 text-background-50',
  热: 'bg-accent-500 text-foreground-950',
  新: 'bg-secondary-500 text-background-50',
  独: 'bg-foreground-900 text-background-50',
};

export default function Feed() {
  const [cat, setCat] = useState('全部');
  const [kw, setKw] = useState('');

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent<string>).detail || '';
      setCat('全部');
      setKw(detail);
    };
    const catHandler = (e: Event) => {
      const detail = (e as CustomEvent<string>).detail || '';
      setCat(detail);
      setKw('');
    };
    window.addEventListener('heigua-search', handler);
    window.addEventListener('heigua-feed', catHandler);
    return () => {
      window.removeEventListener('heigua-search', handler);
      window.removeEventListener('heigua-feed', catHandler);
    };
  }, []);

  const filtered = FEED_ITEMS.filter((it) => {
    if (kw) {
      return (it.title + it.summary).toLowerCase().includes(kw.toLowerCase());
    }
    return cat === '全部' || it.cat === cat;
  });

  return (
    <section id="feed" className="scroll-mt-24 bg-background-50 py-10 md:py-14">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4 md:mb-8">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-primary-600">
              <span className="h-px w-8 bg-primary-400"></span>
              快讯抢先看
            </p>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-[34px]">全网热点速递</h2>
          </div>
          <span className="text-xs text-foreground-500 md:text-sm">聚合娱乐 · 科技 · 社会 · 网络 · 生活等全网热事</span>
        </div>

        {/* category chips */}
        <div className="mb-6 flex flex-wrap items-center gap-2">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => {
                setCat(c);
                setKw('');
              }}
              className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                !kw && cat === c
                  ? 'bg-primary-500 text-background-50'
                  : 'border border-background-300 bg-background-100 text-foreground-700 hover:border-primary-300 hover:text-primary-700'
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {kw && (
          <div className="mb-6 flex flex-wrap items-center gap-3 rounded-xl border border-primary-200 bg-primary-50 px-4 py-3">
            <span className="flex items-center gap-1.5 text-sm text-primary-800">
              <i className="ri-search-line"></i>
              为你筛选关键词「{kw}」，共 {filtered.length} 条相关快讯
            </span>
            <button
              type="button"
              onClick={() => setKw('')}
              className="cursor-pointer text-xs font-semibold text-primary-700 underline underline-offset-2"
            >
              清除搜索
            </button>
          </div>
        )}

        {filtered.length === 0 ? (
          <div className="flex flex-col items-center rounded-2xl border border-dashed border-background-300 bg-background-100 py-20 text-center">
            <span className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-background-200 text-foreground-500">
              <i className="ri-inbox-line text-2xl"></i>
            </span>
            <p className="font-heading text-lg font-bold text-foreground-800">暂无匹配内容</p>
            <p className="mt-1 text-sm text-foreground-500">换个关键词或分类再试试吧</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {filtered.map((it) => (
              <article
                key={it.id}
                className="group cursor-pointer overflow-hidden rounded-2xl border border-background-200 bg-background-100 transition-all hover:-translate-y-1 hover:border-primary-300"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={it.image}
                    alt={`${it.cat}热点话题「${it.title}」资讯配图`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className={`absolute left-3 top-3 rounded-md px-2 py-0.5 text-xs font-bold ${catColor[it.cat] || catColor['娱乐']}`}>
                    {it.cat}
                  </span>
                  <span className={`absolute right-3 top-3 flex h-6 w-6 items-center justify-center rounded-md text-xs font-black ${tagColor[it.tag] || ''}`}>
                    {it.tag}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-[17px]">
                    {it.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{it.summary}</p>
                  <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {it.time}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {(it.read / 10000).toFixed(1)}万
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}